var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"section-title"},[_c('div',{staticClass:"title-left-side"},[_vm._t("icon"),_vm._v(" "),_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"title-right-side"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }